import { useNavigate } from "react-router-dom";
import { LoginForm } from "../../components/Form/LoginForm";
import { LogoContent } from "../../components/LogoSection";
import { ButtonStyled } from "../../style/button";
import { StyledText, StyledTitle } from "../../style/typography";
import { LoginWrapper } from "./style";

export const LoginPage = () => {
  const navigate = useNavigate();
  return (
    <LoginWrapper>
      <div>
        <section>
          <StyledTitle
            tag="heading3"
            titleStyle="heading3"
            alignSelf="flex-start"
          >
            Login
          </StyledTitle>
          <LoginForm />
          <div>
            <StyledText
              tag="body"
              textStyle="body"
              color="#999999"
              weigth={400}
            >
              Crie sua conta para saborear muitas delícias e matar sua fome!
            </StyledText>
          </div>
          <ButtonStyled
            buttonStyle="secondaryMedium"
            weigth={600}
            onClick={() => navigate("/register")}
          >
            Cadastrar
          </ButtonStyled>
        </section>
        <section>
          <LogoContent />
        </section>
      </div>
    </LoginWrapper>
  );
};
